import { slugify } from "../../utils/slugify";

export const readerDocsData = [
  {
  slug: "beginners_guide_to_html",
  title: "Beginners Guide to HTML",
  miniTitles: [
    { title: "Getting Started", page: 3 },
    { title: "Tags, Attributes and Elements", page: 9 },
    { title: "Titles. Headings. Paragraphs", page: 14},
    { title: "Unnumbered, Numbered, Definition and Nested Lists", page: 19 },
    { title: "How to Makes Links to Other Pages and Elsewhere", page: 25},
    { title: "How to Work with Images", page: 29 },
    { title: "How to Use Tabular Data", page: 33 },
    { title: "Text Boxes and Other User-Input 'Thingamajigs'", page: 40 },
    { title: "HTML for Begginers: CSS", page: 45},
    { title: "Putting It All Together", page: 51},  
   ].map(m => ({  ...m, slug: slugify(m.title)})), 
  level: 100,
  subject: "Beginners Guide to HTML",
},
{
  slug: "html-css-design-and-build-websites",
  title: "HTML&CSS Design and Build Websites",
  miniTitles: [
    { title: "Introduction", page: 9},
    { title: "Chapter 1: Structure", page: 18},
    { title: "Chapter 2: Text", page: 46},
    { title: "Chapter 3: Lists", page: 68},
    { title: "Chapter 4: Links", page: 80},
    { title: "Chapter 5: Images", page: 100},
    { title: "Chapter 6: Table", page: 132},
    { title: "Chapter 7: Forms", page: 150},
    { title: "Chapter 8: Extra Markup", page: 182},
    { title: "Chapter 9: Flash, Video & Audio", page: 206},
    { title: "Chapter 10: Introducing CSS", page: 232},
    { title: "Chapter 11: Color", page: 252},
    { title: "Chapter 12: Text", page: 270},
    { title: "Chapter 13: Boxes", page: 306},
    { title: "Chapter 14: Lists, Tables & Forms", page: 336},
    { title: "Chapter 15: Layout", page: 364},
    { title: "Chapter 16: Images", page: 412},
    { title: "Chapter 17: HTML5 Layout", page: 434},
    { title: "Chapter 18: Process & Design", page: 458},
    { title: "Chapter 19: Practical Information", page: 482},
    { title: "Index", page: 499},
  ].map(m => ({  ...m, slug: slugify(m.title)})), 
  level: 200,
  subject: " HTML & CSS Design and Build Websites"
}
]